<!-- =========================================================================================
  File Name: TheNavbar.vue
  Description: Navbar component
  Component Name: TheNavbar
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
    <div class="relative">
        <div class="vx-navbar-wrapper" :class="classObj">
            <vs-navbar
                class="vx-navbar navbar-custom navbar-skelton"
                :color="navbarColorLocal"
                :class="textColor"
            >
                <!-- SM - OPEN SIDEBAR BUTTON -->
                <feather-icon
                    class="sm:inline-flex xl:hidden cursor-pointer p-2"
                    icon="MenuIcon"
                    @click.stop="showSidebar"
                />

                <!-- <bookmarks :navbarColor="navbarColor" v-if="windowWidth >= 992" /> -->

                <vs-spacer />
                <!-- <switch-org-drop-down v-if="userHasRole('SuperUser')" class="mr-4"></switch-org-drop-down> -->
                <span
                    v-if="
                        has_role('Content_Creator') &&
                        !edition.isPublishing &&
                        edition.nonScheduledItems
                    "
                    class="mr-5"
                >
                    {{ itemsScheduled }}
                    Queued for Publishing
                </span>
                <div class="flex" v-if="has_role('Content_Creator')">
                    <div class="flex" v-if="edition.isPublishing && edition.items">
                        <div v-if="edition.isPublishing && edition.startedPublishing">
                            <span class="mr-5">
                                {{ publishedItemCount }}
                                /
                                {{ itemsToPublish }}
                                Publishing
                            </span>
                            <vx-action-icon class="mr-5" icon="LoaderIcon" spin />
                        </div>
                        <div v-else>
                            <span class="mr-5"> Waiting for the publisher to start </span>
                        </div>
                    </div>
                    <vx-action-icon
                        v-else
                        class="mr-5"
                        icon="UploadCloudIcon"
                        hover-color="blue"
                        @click.stop="publish"
                        tooltipPosition="bottom"
                        tooltip="Publish to Zutak"
                        :disabled="edition.isPublishing"
                    />
                </div>
                <profile-drop-down />
            </vs-navbar>
        </div>
    </div>
</template>

<script>
import VxActionIcon from '../../../components/generic/VxActionIcon.vue'
// import Bookmarks from './components/Bookmarks.vue'
// import SearchBar from './components/SearchBar.vue'
import NotificationDropDown from './components/NotificationDropDown.vue'
import ProfileDropDown from './components/ProfileDropDown.vue'
// import SwitchOrgDropDown from './components/SwitchOrgDropDown.vue'
import { mapGetters } from 'vuex'

export default {
    name: 'the-navbar-vertical',
    props: {
        navbarColor: {
            type: String,
            default: '#fff'
        }
    },
    components: {
        // Bookmarks,
        // SearchBar,
        NotificationDropDown,
        ProfileDropDown,
        VxActionIcon
        // SwitchOrgDropDown
    },
    data() {
        return {}
    },
    computed: {
        ...mapGetters({
            has_role: 'auth/has_role',
            edition: 'auth/edition'
        }),
        navbarColorLocal() {
            return this.$store.state.theme === 'dark' && this.navbarColor === '#fff'
                ? '#10163a'
                : this.navbarColor
        },
        verticalNavMenuWidth() {
            return this.$store.state.verticalNavMenuWidth
        },
        textColor() {
            return {
                'text-white':
                    (this.navbarColor != '#10163a' && this.$store.state.theme === 'dark') ||
                    (this.navbarColor != '#fff' && this.$store.state.theme !== 'dark')
            }
        },
        windowWidth() {
            return this.$store.state.windowWidth
        },

        // NAVBAR STYLE
        classObj() {
            if (this.verticalNavMenuWidth == 'default') return 'navbar-default'
            else if (this.verticalNavMenuWidth == 'reduced') return 'navbar-reduced'
            else if (this.verticalNavMenuWidth) return 'navbar-full'
        },
        publishedItemCount() {
            if (!this.edition) {
                return 0
            }
            let count = this.edition.items
                .filter((x) => x.status == 3)
                .sum((x) => x.imageIdsCount + x.audioTracksCount + 1)
            return count
        },
        itemsToPublish() {
            if (!this.edition) {
                return 0
            }
            return this.edition.items.sum((x) => x.imageIdsCount + x.audioTracksCount + 1)
        },
        itemsScheduled() {
            if (!this.edition || !this.edition.nonScheduledItems) {
                return 0
            }
            return this.edition.nonScheduledItems.sum(
                (x) => x.imageIdsCount + x.audioTracksCount + 1
            )
        }
    },
    methods: {
        showSidebar() {
            this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', true)
        },
        async publish() {
            try {
                this.notifySuccess(
                    'Publishing...',
                    'This could take a little while depending on how many changes need to be published',
                    7000
                )
                var response = await this.$api.content.publish()
                this.notifySuccess('Published Successfully', '', 5000)
            } catch (e) {}
        }
    }
}
</script>
<style scoped>
@media only screen and (max-width: 576px) {
    .vx-navbar-wrapper {
        padding: 0 !important;
    }
}
</style>
